var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertGuidance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 25.3333C2.66667 20.1333 6.8 16 12 16C15.3333 16 18.4 17.7333 20.1333 20.6667L22.4 19.3333C21.0667 17.0667 19.0667 15.3333 16.8 14.4C18.8 12.9333 20 10.5333 20 8C20 3.6 16.4 0 12 0C7.6 0 4 3.6 4 8C4 10.5333 5.2 12.9333 7.2 14.4C2.93333 16.2667 0 20.4 0 25.3333V32H16V29.3333H2.66667V25.3333ZM6.66667 8C6.66667 5.06667 9.06667 2.66667 12 2.66667C14.9333 2.66667 17.3333 5.06667 17.3333 8C17.3333 10.9333 14.9333 13.3333 12 13.3333C9.06667 13.3333 6.66667 10.9333 6.66667 8Z",
    fill: "#0076E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1334 21.0659L22.0001 31.1992L15.7334 24.9326L17.6001 23.0659L22.0001 27.4659L30.2667 19.1992L32.1334 21.0659Z",
    fill: "#0076E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertGuidance);
export default __webpack_public_path__ + "static/media/expert-guidance.3e631d9089baaa19f59d49a4639cd5e2.svg";
export { ForwardRef as ReactComponent };